import { api } from './client';
import type { Session, Template, TemplateConfig } from '@/types';

export function listTemplates(): Promise<Template[]> {
  return api<Template[]>('/api/templates');
}

export function createTemplate(body: { name: string; config: TemplateConfig }): Promise<Template> {
  return api<Template>('/api/templates', { method: 'POST', body });
}

export function deleteTemplate(id: string): Promise<void> {
  return api<void>(`/api/templates/${id}`, { method: 'DELETE' });
}

export function launchTemplate(id: string): Promise<Session> {
  return api<Session>(`/api/templates/${id}/launch`, { method: 'POST' });
}
